<template>
  <div class="sku-page">
    <div class="sku-page__header">
      <Title title="SKU 管理"></Title>
      <div class="sku-page__actions">
        <el-button icon="el-icon-refresh" @click="getList(false)">刷新</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addObj">新增 SKU</el-button>
      </div>
    </div>

    <el-card class="sku-panel" shadow="never">
      <el-form :inline="true" :model="search_op" class="sku-filters" size="small">
        <el-form-item label="关键词">
          <el-input
            v-model="search_op.keyword"
            clearable
            placeholder="SKU 名称 / key"
            @clear="getList"
            @keyup.enter.native="getList">
          </el-input>
        </el-form-item>
        <el-form-item label="套餐">
          <el-select v-model="search_op.plan_id" clearable filterable placeholder="全部套餐" @change="getList">
            <el-option
              v-for="plan in plan_list"
              :key="plan.id"
              :label="plan.plan_name + ' / ' + plan.plan_key"
              :value="plan.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台">
          <el-select v-model="search_op.platform" clearable placeholder="全部平台" @change="getList">
            <el-option
              v-for="item in platform_arr"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="search_op.sku_type" clearable placeholder="全部类型" @change="getList">
            <el-option label="标准 SKU" value="normal"></el-option>
            <el-option label="自定义 SKU" value="custom"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search_op.enabled" clearable placeholder="全部状态" @change="getList">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loading="loading"
        :data="list"
        border
        size="small"
        class="sku-table">
        <el-table-column prop="sku_name" label="SKU" min-width="210" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="sku-name">{{ scope.row.sku_name }}</div>
            <div class="sku-key">{{ scope.row.sku_key }}</div>
          </template>
        </el-table-column>
        <el-table-column label="套餐" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.plan_name || '-' }}</div>
            <div class="sku-key">{{ scope.row.plan_key || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="模式" width="90">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.plan_mode === 'snapshot' ? 'warning' : 'info'">
              {{ modeLabel(scope.row.plan_mode) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="90">
          <template slot-scope="scope">{{ typeLabel(scope.row.sku_type) }}</template>
        </el-table-column>
        <el-table-column label="规格" min-width="190">
          <template slot-scope="scope">
            <span>{{ platformLabel(scope.row.platform) }}</span>
            <span class="split">/</span>
            <span>{{ timeLimitText(scope.row.time_limit) }}</span>
            <span class="split">/</span>
            <span>{{ scope.row.allow_device_num }} 台</span>
          </template>
        </el-table-column>
        <el-table-column label="价格" min-width="150">
          <template slot-scope="scope">
            <div>套餐 {{ priceText(scope.row.price) }}</div>
            <div class="sku-key">单设备 {{ priceText(scope.row.one_device_price) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="70"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag v-if="Number(scope.row.enabled) === 1" size="mini" type="success">启用</el-tag>
            <el-tag v-else size="mini" type="info">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="备注" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              size="mini"
              :type="Number(scope.row.enabled) === 1 ? 'warning' : 'success'"
              @click="setEnabled(scope.row, Number(scope.row.enabled) === 1 ? 0 : 1)">
              {{ Number(scope.row.enabled) === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="sku-pagination"
        :current-page="page_num"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import Title from './components/Title'
import apis from '@/api/index'

export default {
  name: 'SkuList',
  components: {
    Title
  },
  data() {
    return {
      loading: false,
      list: [],
      plan_list: [],
      page_num: 1,
      page_size: 20,
      total: 0,
      search_op: {
        keyword: '',
        plan_id: '',
        platform: '',
        sku_type: '',
        enabled: ''
      },
      platform_arr: [
        { name: 'Windows', value: 'win32' },
        { name: 'macOS', value: 'darwin' },
        { name: 'Android', value: 'android' },
        { name: 'iOS', value: 'ios' },
        { name: '全平台', value: 'all' }
      ]
    }
  },
  methods: {
    getList(toFirst = true) {
      if (toFirst) {
        this.page_num = 1
      }
      this.loading = true
      const params = Object.assign({
        page_num: this.page_num,
        page_size: this.page_size
      }, this.search_op)
      apis.activation_code.readSkuPage(params).then(res => {
        const data = res.data.data || {}
        this.list = data.list || []
        this.total = data.count || 0
      }).finally(() => {
        this.loading = false
      })
    },
    getPlans() {
      apis.license.readPlans({ page_num: 1, page_size: 200 }).then(res => {
        const data = res.data.data || {}
        this.plan_list = data.list || []
      })
    },
    resetFilters() {
      this.search_op = {
        keyword: '',
        plan_id: '',
        platform: '',
        sku_type: '',
        enabled: ''
      }
      this.getList()
    },
    handleEdit(row) {
      this.$router.push({ name: 'updateCodeType', query: { id: row.id } })
    },
    setEnabled(row, enabled) {
      const params = Object.assign({}, row, { enabled })
      apis.activation_code.saveSku(params).then(res => {
        this.$message({ message: res.data.msg, type: res.data.code ? 'success' : 'error' })
        if (res.data.code) {
          this.getList(false)
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确认删除 SKU「${row.sku_name}」？已被使用的 SKU 会改为禁用。`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.activation_code.deleteSku({ sku_id: row.id }).then(res => {
          this.$message({ message: res.data.msg, type: res.data.code ? 'success' : 'error' })
          if (res.data.code) {
            this.getList(false)
          }
        })
      }).catch(() => {})
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page_num = val
      this.getList(false)
    },
    addObj() {
      this.$router.push({ name: 'addCodeType' })
    },
    platformLabel(value) {
      const item = this.platform_arr.find(op => op.value === value)
      return item ? item.name : value
    },
    timeLimitText(value) {
      const num = Number(value)
      if (num === 0) return '永久'
      if (num === 365) return '一年'
      if (num === 30) return '一个月'
      if (num === 7) return '7 天'
      if (num === 1) return '1 天'
      if (num < 1) return `${num * 24} 小时`
      return `${num} 天`
    },
    priceText(value) {
      return `￥${Number(value || 0).toFixed(2)}`
    },
    typeLabel(value) {
      return value === 'custom' ? '自定义' : '标准'
    },
    modeLabel(value) {
      return value === 'snapshot' ? '快照' : '动态'
    }
  },
  activated() {
    this.getList(false)
  },
  mounted() {
    this.getPlans()
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.sku-page {
  padding: 15px;
}

.sku-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
}

.sku-page__actions {
  display: flex;
  gap: 10px;
}

.sku-panel {
  border-radius: 4px;
}

.sku-filters {
  margin-bottom: 12px;
}

.sku-table {
  width: 100%;
}

.sku-name {
  color: #222;
  font-weight: 600;
  line-height: 22px;
}

.sku-key {
  color: #888;
  font-size: 12px;
  line-height: 20px;
}

.split {
  color: #bbb;
  margin: 0 6px;
}

.sku-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
